export default __webpack_public_path__ + "static/media/la.f0644bcb.png";